import * as z from "zod";
import { webhookEventSchema } from "./get-webhook-events";

export const resendWebhookEvent = {
  name: "resendWebhookEvent" as const,
  input: z.object({ webhookEventId: z.string() }),
  output: z.object({
    event: webhookEventSchema,
    successful: z.boolean(),
    statusCode: z.number().optional(),
    responseText: z.string().optional(),
    errorMessage: z.string().optional(),
  }),
};
